import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text, Icon } from '@ui-kitten/components';
import { StyleSheet, Image, Dimensions } from 'react-native';

const width = Dimensions.get('window').width;

const PlusIcon = (props) => (
  <Icon {...props} name='headphones' />
);

import moment from 'jalali-moment'

export const TopBar = (props) => {
  const [date, setDate] = useState(moment().locale('fa').format('YYYY/MM/DD'))
  const [time, setTime] = useState(moment().locale('fa').format('HH:mm'))

  var timer;
    clearInterval(timer);
    timer = setInterval(()=>{
      setTime(moment().locale('fa').format('HH:mm'));
      setDate(moment().locale('fa').format('YYYY/MM/DD'))
    },5000)
  return (
        <Layout style={styles.topContainer}>
          <SafeAreaView style={{alignItems:'center'}}>
            <Text category='h6' style={styles.text}>{props.title}</Text>
          </SafeAreaView>
        </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    backgroundColor:'#417CBE',
    justifyContent:'flex-start',
    alignItems:'center'
  },
  topContainer: {
    flexDirection:'row',
    justifyContent: 'center',
    backgroundColor:'#134A93',
    height:90,
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    paddingVertical: 10,
    paddingHorizontal:10,
    width

  },
  layout: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color:'#ffffff'
  }
});
